import { db } from '../firebase';
import { 
  collection, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  getDocs, 
  getDoc,
  query,
  orderBy,
  serverTimestamp 
} from 'firebase/firestore';

const COLLECTION = 'blog_posts';

export const createPost = async (postData) => {
  try {
    const docRef = await addDoc(collection(db, COLLECTION), {
      ...postData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    return { id: docRef.id, ...postData };
  } catch (error) {
    console.error('Error creating post:', error);
    throw error;
  }
};

export const updatePost = async (id, postData) => {
  try {
    const docRef = doc(db, COLLECTION, id);
    await updateDoc(docRef, {
      ...postData,
      updatedAt: serverTimestamp()
    });
    return { id, ...postData };
  } catch (error) {
    console.error('Error updating post:', error);
    throw error;
  }
};

export const deletePost = async (id) => {
  try {
    await deleteDoc(doc(db, COLLECTION, id));
  } catch (error) {
    console.error('Error deleting post:', error);
    throw error;
  }
};

export const getAllPosts = async () => {
  try {
    const q = query(collection(db, COLLECTION), orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Error getting posts:', error);
    throw error;
  }
};

export const getPost = async (id) => {
  try {
    const docRef = doc(db, COLLECTION, id);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      throw new Error('Post not found');
    }
  } catch (error) {
    console.error('Error getting post:', error);
    throw error;
  }
};

export const getPublishedPosts = async () => {
  try {
    const posts = await getAllPosts();
    return posts
      .filter(post => post.published)
      .map(post => ({
        ...post,
        // Generar slug si no existe
        slug: post.slug || post.title.toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .replace(/\s+/g, '-')
          .trim()
      }));
  } catch (error) {
    console.error('Error getting published posts:', error);
    throw error;
  }
};

// Función para buscar posts por slug
export const getPostBySlug = async (slug) => {
  try {
    const posts = await getPublishedPosts();
    return posts.find(post => post.slug === slug);
  } catch (error) {
    console.error('Error getting post by slug:', error);
    throw error;
  }
};

// Función para obtener posts por categoría
export const getPostsByCategory = async (category) => {
  try {
    const posts = await getPublishedPosts();
    return posts.filter(post => post.category === category);
  } catch (error) {
    console.error('Error getting posts by category:', error);
    throw error;
  }
};

// Función para buscar posts
export const searchPosts = async (searchTerm) => {
  try {
    const posts = await getPublishedPosts();
    const term = searchTerm.toLowerCase();
    return posts.filter(post => 
      post.title.toLowerCase().includes(term) ||
      (post.excerpt && post.excerpt.toLowerCase().includes(term)) ||
      (post.content && post.content.toLowerCase().includes(term)) ||
      (post.tags && post.tags.some(tag => tag.toLowerCase().includes(term)))
    );
  } catch (error) {
    console.error('Error searching posts:', error);
    throw error;
  }
};
